@if (isLoading) {
<div class="loading-box" [class.overlay]="overlay">
  <app-loading [overlay]="overlay"></app-loading>
</div>
} @if (totalNum === 0 && !isLoading) {
<app-no-result-found></app-no-result-found>
}
<div class="table-box" #tablebox [class.hidden]="!fixed" [class.fixed-header]="fixedHeader">
  @if (totalNum > 0 && (!isLoading || overlay)) {
  <cds-table [class.fixed]="fixed" [dataSource]="disPlayData" [class.full]="true">
    @for (item of columnsConfig; track item; let i = $index) {
    <ng-container [cdsColumnDef]="item.key" [sticky]="!!item.sticky && !fixed" [stickyEnd]="!!item.sticky && !fixed">
      <cds-header-cell *cdsHeaderCellDef>
        <div class="header-cell-content">
          @if (tempHeaderCellRefs[item.key]) {
          <ng-container
            [ngTemplateOutlet]="tempHeaderCellRefs[item.key].templateRef"
            [ngTemplateOutletContext]="{
              $implicit: item,
              index: i
            }"></ng-container>
          } @if (!tempHeaderCellRefs[item.key]) {
          <div class="header-cell-title">
            {{ item.title | lang }}
          </div>
          } @if (item.sort) {
          <div class="header-cell-sort">
            @if (item.sort === sortMode.DEFAULT) {
            <cds-icon icon="arrow:sort" (click)="sortChange(item, sortMode.UP)"></cds-icon>
            } @if (item.sort === sortMode.UP) {
            <cds-icon icon="arrow:up" (click)="sortChange(item, sortMode.DOWN)"></cds-icon>
            } @if (item.sort === sortMode.DOWN) {
            <cds-icon icon="arrow:down" (click)="sortChange(item, sortMode.DEFAULT)"></cds-icon>
            }
          </div>
          }
        </div>
      </cds-header-cell>
      <cds-cell *cdsCellDef="let element; let num = index">
        @if (tempBodyCellRefs[item.key]) {
        <ng-container
          [ngTemplateOutlet]="tempBodyCellRefs[item.key].templateRef"
          [ngTemplateOutletContext]="{
            $implicit: element,
            index: num
          }"></ng-container>
        } @if (!tempBodyCellRefs[item.key]) {
        <div>
          {{ element[item.key] | lang }}
        </div>
        }
      </cds-cell>
    </ng-container>
    }
    <cds-header-row *cdsHeaderRowDef="displayedColumns; sticky: fixedHeader"></cds-header-row>
    <cds-row *cdsRowDef="let row; columns: displayedColumns"></cds-row>
  </cds-table>
  }
</div>
@if (totalNum > 0 && (!isLoading || overlay) && isShowPagination) {
<div class="l-pt-4 l-pb-4 l-d-f l-jc-sb">
  <app-pagination [useOf]="true" [pageCount]="pageCount" (pageChange)="pageChange($event)"> </app-pagination>
</div>
}
